module.exports = __webpack_public_path__ + "static/media/icon-heater-blue.1f173184.png";